import FindVegetable from "../../components/Nursery/EnvironmentScience/FindVegetable";
import MatchVegetable from "../../components/Nursery/EnvironmentScience/MatchVegetable";

// Define the type for menu items
interface MenuItem {
    url: string;
    title: string;
    component?: React.FC; // Optional React functional component
    subMenu?: MenuItem[]; // Allow subMenu to be an array of MenuItem
}


document.title = "Mamas Guidance - Nursery - Environmental Science - Vegetables"; // Set page title


const topics: MenuItem[] = [
    { url: "/nursery/environmental-science/vegetables/find-vegetable", title: "Find Vegetable", component: FindVegetable},
    { url: "/nursery/environmental-science/vegetables/match-vegetable", title: "Match Vegetable", component: MatchVegetable},
];


export default topics;